export const SettingIcon = ({
  fill = "None",
  width = "23",
  height = "23",
  strokeColor = "#15112D",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.7555 4.19029C11.8254 3.42177 12.4697 2.83333 13.2414 2.83333H14.7587C15.5304 2.83333 16.1747 3.42177 16.2446 4.19029C16.302 4.82124 16.7561 5.33633 17.3493 5.55866C17.5018 5.61582 17.6525 5.67678 17.8013 5.7414C18.3882 5.9965 19.0787 5.94761 19.5703 5.53787C20.1779 5.03156 21.0713 5.07209 21.6305 5.63133L22.7015 6.70226C23.2347 7.23547 23.2733 8.08727 22.7905 8.66657C22.3885 9.14907 22.351 9.83035 22.6214 10.3973C22.7384 10.6428 22.8452 10.8941 22.9414 11.1507C23.1637 11.7439 23.6788 12.198 24.3098 12.2554C25.0782 12.3253 25.6667 12.9697 25.6667 13.7413V15.2587C25.6667 16.0303 25.0782 16.6747 24.3098 16.7445C23.6788 16.8019 23.1637 17.256 22.9414 17.8493C22.855 18.0796 22.7601 18.3057 22.6569 18.5271C22.4062 19.0652 22.4468 19.7076 22.8268 20.1637C23.289 20.7183 23.2521 21.5339 22.7415 22.0445L21.5445 23.2415C21.034 23.752 20.2184 23.789 19.6637 23.3268C19.2077 22.9468 18.5652 22.9062 18.0271 23.1569C17.8057 23.26 17.5796 23.355 17.3493 23.4413C16.7561 23.6637 16.302 24.1788 16.2446 24.8097C16.1747 25.5782 15.5304 26.1667 14.7587 26.1667H13.2414C12.4697 26.1667 11.8254 25.5782 11.7555 24.8097C11.6981 24.1788 11.244 23.6637 10.6507 23.4413C10.3942 23.3452 10.1429 23.2383 9.89738 23.1213C9.33041 22.851 8.64912 22.8884 8.16661 23.2905C7.58732 23.7732 6.7355 23.7346 6.2023 23.2015L5.13138 22.1305C4.57213 21.5713 4.53161 20.6778 5.03792 20.0702C5.44766 19.5786 5.49655 18.8882 5.24144 18.3012C5.17682 18.1525 5.11587 18.0019 5.05871 17.8493C4.83639 17.256 4.32128 16.8019 3.69034 16.7445C2.92182 16.6747 2.33337 16.0303 2.33337 15.2587V13.7413C2.33337 12.9697 2.92182 12.3253 3.69034 12.2554C4.32129 12.198 4.83639 11.744 5.05872 11.1507C5.12591 10.9714 5.19833 10.7947 5.27581 10.6207C5.54999 10.005 5.50442 9.27633 5.07295 8.75856C4.5468 8.12717 4.58891 7.19875 5.17007 6.61759L6.11762 5.67003C6.69878 5.08887 7.62721 5.04675 8.25859 5.57292C8.77636 6.00439 9.50505 6.04995 10.1207 5.77577C10.2947 5.69829 10.4714 5.62586 10.6507 5.55867C11.244 5.33634 11.6981 4.82125 11.7555 4.19029Z"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 14.5C17.5 16.4331 15.9331 18 14 18C12.067 18 10.5 16.4331 10.5 14.5C10.5 12.567 12.067 11 14 11C15.9331 11 17.5 12.567 17.5 14.5Z"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
